module.exports = "/_next/static/images/home-4873b584fe5b01f631414ef05178ddc4.png";